<div class="content">
  <h2 class="title">Observación final</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <form [formGroup]="form" *ngIf="data">
    <div class="row">
      <div class="col-6">
        <p><b>Número de caso:</b> {{ data.gai }}</p>
      </div>
      <div class="col-6">
        <p><b>Tipo de caso:</b> {{ data.caseType.name }}</p>
      </div>
      <div class="col-6">
        <p><b>Asignado a:</b> {{ data.assigned.fullname }}</p>
      </div>
      <div class="col-6">
        <p><b>Creado por :</b> {{ data.creator.fullname }}</p>
      </div>
      <div class="col-6">
        <p>
          <b>Fecha de creación:</b>
          {{ data.createdAt | date: "d/MM/yyyy h:mm a	" }}
        </p>
      </div>
      <div class="col-6">
        <p>
          <b>última modificación :</b> {{ data.updatedAt | date: "dd/M/yyyy" }}
        </p>
      </div>
      <div class="col-12">
        <p><b>Descripción:</b> {{ data.description }}</p>
      </div>

      <div class="content-component" *ngIf="ComponentValue">
        <ng-template appComponentValue></ng-template>
      </div>

      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>Observaciones</mat-label>
          <textarea matInput formControlName="observations"></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="button">
    <button
      [disabled]="isLoading"
      (click)="finish()"
      mat-raised-button
      class="primary-btn rounded"
    >
      Finalizar
    </button>
  </div>
</div>
